import { memo } from 'react';

import { OrderSpot } from '@/App/tiles/orders/components/OrderSpot.tsx';
import { useTakeProfitTileId } from '@/App/tiles/orders/TakeProfitOrder/TakeProfitOrderCreationTile/takeProfitContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectSpotTakeProfitData } from '@/store/orders/takeProfitOrder/selectors.ts';

export const ConnectedTakeProfitOrderSpot = memo(() => {
  const tileId = useTakeProfitTileId();
  const spotDate = useAppSelector((state) => selectSpotTakeProfitData(state, tileId));

  return <OrderSpot spotDate={spotDate} />;
});
